import { buttonVariants } from '@labflow/ui';
import { Link } from '@tanstack/react-router';

import { StatusScreen } from './status-screen';

/** 없는 경로 — 라우터 기본 not-found. `/`는 세션 상태에 맞는 첫 화면으로 다시 보낸다. */
export function NotFoundScreen() {
  return (
    <StatusScreen
      title="찾는 화면이 없어요"
      description="주소가 바뀌었거나 없어진 화면이에요."
      actions={
        <Link to="/" className={buttonVariants({ variant: 'primary' })}>
          홈으로 가기
        </Link>
      }
    />
  );
}
